import { render } from "./SensorOwner.vue?vue&type=template&id=36147aa0"
import script from "./SensorOwner.vue?vue&type=script&lang=js"
export * from "./SensorOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__